"use client";

export default function ServicesLoadingSpinner() {
  return (
    <div className="space-y-4">
      {/* Skeleton for search input */}
      <div className="h-12 bg-grey-100 rounded-lg animate-pulse" />
      
      {/* Skeleton for service categories */}
      {[1, 2, 3].map((index) => (
        <div
          key={index}
          className="bg-white rounded-lg border border-grey-75 overflow-hidden"
        >
          {/* Category header skeleton */}
          <div className="p-4">
            <div className="flex items-center justify-between">
              <div className="space-y-2">
                <div className="h-5 w-32 bg-grey-100 rounded animate-pulse" />
                <div className="h-4 w-20 bg-grey-100 rounded animate-pulse" />
              </div>
              <div className="h-5 w-5 bg-grey-100 rounded animate-pulse" />
            </div>
          </div>
        </div>
      ))}
      
      {/* Loading message */}
      <div className="flex items-center justify-center py-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-300 mx-auto mb-3"></div>
          <p className="text-grey-600 text-sm">Loading services...</p>
        </div>
      </div>
    </div>
  );
}
